const formatCurrency = (currency: any, amount: any) => {
  if (isNaN(amount) || amount <= 0) {
    return 'Undisclosed'
  }

  const formattedAmount = new Intl.NumberFormat('en', {
    style: 'currency',
    currency: currency,
    currencyDisplay: 'code',
    notation: 'compact',
    compactDisplay: 'long'
  }).format(amount)

  if (formattedAmount.endsWith('B')) {
    return formattedAmount.replace('B', 'Bn')
  }
  return formattedAmount
}

export {
  formatCurrency
}
